import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from '../../../auth/services/auth-service';
import {Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-home-component',
  standalone: true,
  templateUrl: './home-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home-component.scss'
})
export class HomeComponent {

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  constructor() {
    this.authService.isAuthenticated()
      .pipe(takeUntilDestroyed())
      .subscribe(result => {
        if (result) {
          this.router.navigate(['/main']);
        }
      });
  }
}
